import { useEffect, useState } from "react";

export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(() => {
    if (typeof navigator === "undefined") return true;
    return navigator.onLine && sessionStorage.getItem("mola-network-offline") !== "1";
  });
  useEffect(() => {
    const markOnline = (): void => { sessionStorage.removeItem("mola-network-offline"); setOnline(true); };
    const markOffline = (): void => { sessionStorage.setItem("mola-network-offline", "1"); setOnline(false); };
    const verifyReachability = async (): Promise<void> => {
      if (!navigator.onLine) { markOffline(); return; }
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 3_000);
      try {
        const response = await fetch(`/health?connectivity=${Date.now()}`, { cache: "no-store", signal: controller.signal });
        if (!response.ok) throw new Error("health unavailable");
        markOnline();
      } catch {
        markOffline();
      } finally {
        window.clearTimeout(timeout);
      }
    };
    window.addEventListener("online", markOnline);
    window.addEventListener("offline", markOffline);
    void verifyReachability();
    return () => {
      window.removeEventListener("online", markOnline);
      window.removeEventListener("offline", markOffline);
    };
  }, []);
  return online;
}
